import { IResourceComponentsProps } from "@refinedev/core";
import { Edit, useForm } from "@refinedev/antd";
import { Form, Input, Checkbox } from "antd";
import { UPDATE_VENDOR_MUTATION, VENDOR_ONE_QUERY } from "./queries";

export const EditVendor: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps } = useForm({
    meta: {
      gqlQuery: VENDOR_ONE_QUERY,
      gqlMutation: UPDATE_VENDOR_MUTATION,
    },
  });


  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Company Name"
          name="companyName"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Is Local" name="isLocal" valuePropName="checked">
          <Checkbox>Is Local Vendor</Checkbox>
        </Form.Item>
        <Form.Item label="TIN" name="tin">
          <Input />
        </Form.Item>

        <h3>Address Information</h3>
        <Form.Item label="Address Line" name={["address", "addressLine"]}>
          <Input />
        </Form.Item>
        <Form.Item label="City" name={["address", "city"]}>
          <Input />
        </Form.Item>
        <Form.Item label="Country" name={["address", "country"]}>
          <Input />
        </Form.Item>
        <Form.Item label="Email" name={["address", "email"]}>
          <Input />
        </Form.Item>
        <Form.Item label="P.O. Box" name={["address", "pobox"]}>
          <Input />
        </Form.Item>
        <Form.Item label="Phones (comma separated)" name={["address", "phones"]}>
          <Input.TextArea />
        </Form.Item>

        <h3>Contact Person Information</h3>
        <Form.Item
          label="Contact Name"
          name={["contact", "name"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Contact Address Line" name={["contact", "address", "addressLine"]}>
          <Input />
        </Form.Item>
        <Form.Item label="Contact City" name={["contact", "address", "city"]}>
          <Input />
        </Form.Item>
        <Form.Item label="Contact Country" name={["contact", "address", "country"]}>
          <Input />
        </Form.Item>
        <Form.Item label="Contact Email" name={["contact", "address", "email"]}>
          <Input />
        </Form.Item>
        <Form.Item label="Contact P.O. Box" name={["contact", "address", "pobox"]}>
          <Input />
        </Form.Item>
        <Form.Item label="Contact Phones (comma separated)" name={["contact", "address", "phones"]}>
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Edit>
  );
};